<template>
  <a-upload
    name="file"
    accept="image/*"
    :maxCount="1"
    action="/admin/upload/img"
    :show-upload-list="false"
    @change="handleUploadChange"
  >
    <a-button>
      <upload-outlined></upload-outlined>
      上传图片识别
    </a-button>
  </a-upload>
</template>

<script setup>
import { computed, ref } from 'vue'
import { PlusOutlined, UploadOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
const props = defineProps({
  cover: {
    type: String,
    default: '',
  },
  listType: {
    type: String,
    default: 'picture-card',
  },
})
const emit = defineEmits(['uploadSuccess'])
const uploadLoading = ref(false)
// 图片地址
const coverSrc = computed(() => props.cover || '')

const handleUploadChange = (info) => {
  if (info.file.status === 'uploading') {
    uploadLoading.value = true
    return
  }
  if (info.file.status === 'done') {
    if (info.file.response && info.file.response.status === 0) {
      const url = info.file.response.data
      emit('uploadSuccess', url)
    }
    uploadLoading.value = false
  }
  if (info.file.status === 'error') {
    uploadLoading.value = false
    message.error('上传失败')
  }
}
</script>

<style>
.cover_img {
  width: 100px;
  height: 100px;
  display: inline-block;
}
</style>
